import { ShareLink } from "@/components/ShareLink/ShareLink";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle";

export function PlaygroundShareLink() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Basic Usage</PlaygroundSubSectionTitle>
        <p className="text-sm font-normal text-muted-foreground">
          Ghost icon-only button that copies the current URL. Hover to reveal
          the tooltip, click to copy the link and show a success toast.
        </p>
        <div className="flex items-center gap-4">
          <ShareLink />
        </div>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>In context</PlaygroundSubSectionTitle>
        <p className="text-sm font-normal text-muted-foreground">
          As it appears next to other header actions.
        </p>
        <div className="flex items-center gap-2 rounded-md bg-card p-2">
          <span className="text-sm font-medium text-foreground">
            Call recording
          </span>
          <ShareLink />
        </div>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
